import { ModelTranslator } from '@/types/ApiResponseTypes'
import { TicketListRequestBody } from '@/types/support/TicketRequestType'
import { TicketListRequest, isTicketListRequest } from '@/types/support/TicketType'

class TicketListRequestTranslator implements ModelTranslator<TicketListRequest> {
  convertToModel(model: any): TicketListRequestBody {
    if (isTicketListRequest(model)) {
      if ('filters' in model) {
        const result = {
          page: model.page,
          pageSize: model.pageSize,
          statusid: model.statusid,
        }
        return { ...result, ...model.filters }
      }
      return {
        page: model.page,
        pageSize: model.pageSize,
        statusId: model.statusid,
        ticketId: model.ticketId,
      }
    }
    return { page: 1, pageSize: -1, statusId: 0, ticketId: 0 }
  }
}

export default new TicketListRequestTranslator()
